'use client';

import NextImage from '@/components/atoms/Image';
import { useModernLayoutContext } from '@/features/HomepageHero/components/Context';
import { cn } from '@/lib/utils';
import { HOMEPAGE_HERO_IMAGE_SIZES } from '@/utils/imgSizes';
import { HomepageHeroCarouselContent } from '../HomepageHeroStrapi';
import { HOMEPAGE_HERO_IMAGE_QUALITY } from '../consts';

type Props = {
  index: number;
  slide: HomepageHeroCarouselContent;
};

// NOTE: used to be controlled by height-0 vs height-auto, but Safari doesn't like that
// inset-0 has also been removed, so if things start looking odd, start by bringing it back
const safariSupportedDisplayStyles = 'z-10 opacity-100';
const safariSupportedHiddenStyles = 'z-0 opacity-0';

const HomepageHeroSlideImage = (props: Props) => {
  const { index, slide } = props;
  const { activeSlideIndex } = useModernLayoutContext();
  const isFirst = index === 0;

  const isActive = index === activeSlideIndex;

  return (
    <NextImage
      data-o10n-index={index}
      loading={isFirst ? 'eager' : 'lazy'}
      fetchPriority={isFirst ? 'high' : undefined}
      quality={HOMEPAGE_HERO_IMAGE_QUALITY}
      sizes={HOMEPAGE_HERO_IMAGE_SIZES}
      {...slide.image.image?.data?.attributes}
      src={slide.image?.image?.data?.attributes?.url ?? ''}
      alt={slide.image?.image?.data?.attributes?.alternativeText ?? ''}
      classNames={{
        container: cn(
          'items-center justify-center w-full flex',
          'top-1/2 -translate-y-1/2 absolute',

          isActive ? safariSupportedDisplayStyles : safariSupportedHiddenStyles
        ),
        image: 'rounded-m h-auto w-full',
      }}
    />
  );
};

export default HomepageHeroSlideImage;
